export default function checkVersion() {
    const CURRENT_VERSION = process.env.VUE_APP_VERSION;
    const storedVersion = localStorage.getItem('app_version');
    
    // Trigger reload if version missing OR different
    if (!storedVersion || storedVersion !== CURRENT_VERSION) {
        localStorage.setItem('app_version', CURRENT_VERSION);
        window.location.reload();
    }
}